import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ViewTile } from '../../../models/view-tile';

@Component({
    selector: 'ddv-peer-carousel',
    templateUrl: './peer-carousel.component.html',
    styleUrls: ['./peer-carousel.component.scss'],
    imports: [
        NgClass,
    ],
})
export class PeerCarouselComponent {
    @Input() group: ViewTile | undefined;
    @Input() selectedDashboardId: string | undefined;

    @Output() selectedDashboardIdChange = new EventEmitter<string>();

    protected onDashboardDotClicked(dashboardId?: string): void {
        // the types say the dashboarId is a string, but the MW sometimes returns a number
        const id = dashboardId?.toString();
        if (id === this.selectedDashboardId) {
            return;
        }

        this.selectedDashboardIdChange.emit(id);
    }
}
